import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { useModalContext } from '../ModalContext';
import { ModalTriggerProps } from '../types';

const ModalTrigger = ({
  children,
  as = 'span',
  dataTestId,
  isDisabled = false,
  fullWidth = false,
}: ModalTriggerProps) => {
  const { open } = useModalContext();

  return (
    <Container
      as={as}
      onClick={isDisabled ? undefined : open}
      data-testid={dataTestId}
      width={fullWidth ? '100%' : undefined}
    >
      {children}
    </Container>
  );
};

ModalTrigger.displayName = 'ModalTrigger';

export default ModalTrigger;
